import { useState, useEffect } from "react";
import ServiceAPI from "../../../service/ServiceAPI";
import { calculateLockerCompletionPercentage } from "./CompleteInventoryUtils";

import { Button, Grid, Box } from "@material-ui/core";
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import LinearProgress from '@material-ui/core/LinearProgress'; 
import Constants from '../../../utils/Constants';

const LockerSelectionView = (props) => {
  console.assert(props.workflowViews);
  console.assert(props.setCurrentView);
  console.assert(props.inventoryData);
  console.assert(props.handleSelectedLocker);
  console.assert(props.completionRecord);

  console.log("LockerSelectionView->InventoryData", props.inventoryData);
  
  /**
   * 
   * @param {*} container 
   */
  const handleClick_selectLocker = (container) => {
    props.handleSelectedLocker(container);
    props.setCurrentView(props.workflowViews.LockerContentView);
  }

  /**
   * Event handler for the Complete Inventory button, which will finalise 
   * the inventory transcript and generate and send the report to the 
   * Briagde Email.
   */
  const handleClick_inventoryComplete = (completionRecord) => {
    props.setCurrentView(props.workflowViews.CompletionRecordSelectionView);

    if (completionRecord.getCompleted() !== null) {
      return;
    }
    
    completionRecord.setCompleted(new Date().toISOString());     
     
    ServiceAPI.CompletionRecord().updateExistingCompletionRecord(completionRecord).then( () => {
      console.log("About to call the Report")
      ServiceAPI.CompletionRecord().createInventoryCompletionTranscriptRecordReportAndEmail(completionRecord);
    });

  }

  /**
   * 
   */
  const render = function() {
    if (props.inventoryData === null) {
      return <h1>Loading Inventory...</h1>
    }
    
    let percentages = [];

    props.inventoryData.getContainers().map( (container) => {
      let containerId = container.getId();
      let completionPercentage = calculateLockerCompletionPercentage(container, props.completionRecord);

      percentages.push({id: containerId, percentage: completionPercentage});
    });



    return (
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="left"
        spacing={4}
        m={2}
      >
        { renderLockers(percentages) }
        { renderCompleteInventoryButton(percentages) }
      </Grid>
    );
  }

  /**
   * 
   */
  const renderProgressBar = (percent) => {

    return (
      <Box display="flex" alignItems="center">
        <Box width="100%" mr={1}>
          <LinearProgress variant="determinate" value={percent} />
        </Box>
        <Box minWidth={35}>
          <Typography variant="body2" color="textSecondary">{`${Math.round(percent)}%`}</Typography>
        </Box>
      </Box>
    );
  }
  /**
   * 
   */
  const renderLockers = (percentages) => {
    return props.inventoryData.getContainers().map( (container) => {
      return (
        <Card style={{maxWidth: '80%', margin: '2em', backgroundColor: 'whitesmoke'}}>
          <CardActionArea>
            <CardContent onClick={() => handleClick_selectLocker(container) }>
              <Typography gutterBottom variant="h5" component="h2">
                { container.getName() }
              </Typography>
              { renderProgressBar( percentages.filter((o) => o.id == container.getId())[0].percentage ) }
            </CardContent>
          </CardActionArea>
        </Card>
      );
    });
  }

  const renderCompleteInventoryButton = (percentages) => {
    let allComplete = true;

    percentages.forEach((o) => {
      if (allComplete === false) {
        return;
      }

      allComplete = (o.percentage === 100);
    });


    return (
      <Button 
        variant="contained" 
        color="primary" 
        size="large" 
        style={{margin: '1em'}} 
        disabled={ !allComplete } 
        onClick={() => { handleClick_inventoryComplete(props.completionRecord) }}
      >
        Inventory Complete
      </Button>
    );
  }

  return render();
}

export default LockerSelectionView;